import { paths } from '../routes/paths';

// The first-run tour, one list per role. `id` matches a data-tour attribute on the real
// screen and `path` is the screen it lives on; a step is skipped when its target is absent.
const adminShell = [
  {
    id: 'sidebar',
    path: paths.dashboard.session.audio.root,
    title: 'Sidebar',
    body: 'Everything you can open is here; the groups match your role.',
  },
  {
    id: 'menu',
    path: paths.dashboard.session.audio.root,
    title: 'Your menu',
    body: 'Your profile, the tour, and sign out.',
  },
];

const consoleShell = (path) => [
  {
    id: 'panels',
    path,
    title: 'Panels',
    body: 'Everything you can open is here; the list matches your role.',
  },
  {
    id: 'menu',
    path,
    title: 'Your status',
    body: 'Your availability, the tour, and sign out.',
  },
];

export const TOUR_STEPS = {
  admin: [
    ...adminShell,
    {
      id: 'review',
      path: paths.dashboard.review,
      title: 'Review overview',
      body: 'Everything waiting for a second pair of eyes.',
    },
    {
      id: 'content',
      path: paths.dashboard.content.taxonomy,
      title: 'Content',
      body: 'The taxonomy; audio and images sit under Session and Asset Manager.',
    },
    {
      id: 'devices',
      path: paths.dashboard.devices.root,
      title: 'Devices',
      body: 'Fleet, user links and firmware.',
    },
    {
      id: 'team',
      path: paths.dashboard.team,
      title: 'Team',
      body: 'Members and roles; shifts are under Support, Team.',
    },
  ],
  support_agent: [
    ...consoleShell(paths.dashboard.support.console),
    {
      id: 'queue-tabs',
      path: paths.dashboard.support.console,
      title: 'Queue tabs',
      body: 'Open, waiting and closed conversations.',
    },
    {
      id: 'composer',
      path: paths.dashboard.support.console,
      title: 'Composer',
      body: 'Reply, or pick a macro.',
    },
    {
      id: 'resolve',
      path: paths.dashboard.support.console,
      title: 'Resolve',
      body: 'Close as resolved or unresolved, with a reason.',
    },
  ],
  sleep_coach: [
    ...consoleShell(paths.dashboard.insights.root),
    {
      id: 'caseload',
      path: paths.dashboard.insights.root,
      title: 'Your caseload',
      body: 'Search by name, email or phone.',
    },
    {
      id: 'night',
      path: paths.dashboard.insights.root,
      title: 'Night charts',
      body: 'One night at a time; the date pill picks the night.',
    },
    {
      id: 'panel',
      path: paths.dashboard.insights.root,
      title: 'Customer panel',
      body: 'Profile, Notes, Logs and Intake for the customer you picked.',
    },
    {
      id: 'chat',
      path: paths.dashboard.coach.console,
      title: 'Chat',
      body: 'The coaching conversations; open one to reply.',
    },
  ],
  // Any other roster role works in the admin shell and gets its two shell steps.
  staff: adminShell,
};
